import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Ontbijten, essentieel of niet?</title>
                <link rel="canonical" href={route("blogs.fifty-three")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hallo daar, ontbijtliefhebbers en vastenfanatici! Vandaag gaan we het hebben over een onderwerp dat zo oud is als de tijd zelf (of in ieder geval zo oud als de uitvinding van de cornflakes): het ontbijt. Is het echt de belangrijkste maaltijd van de dag, of is het gewoon een slimme marketingtruc van de Kellogg's van deze wereld? Laten we eens duiken in de wereld van de vroege vogels en de late slapers. WE ARE – Personal training Uden en Schijndel. "
                />
                <meta
                    property="og:description"
                    content="Hallo daar, ontbijtliefhebbers en vastenfanatici! Vandaag gaan we het hebben over een onderwerp dat zo oud is als de tijd zelf (of in ieder geval zo oud als de uitvinding van de cornflakes): het ontbijt. Is het echt de belangrijkste maaltijd van de dag, of is het gewoon een slimme marketingtruc van de Kellogg's van deze wereld? Laten we eens duiken in de wereld van de vroege vogels en de late slapers. WE ARE – Personal training Uden en Schijndel. "
                />
                <meta property="og:url" content={route("blogs.fifty-three")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Ontbijten, essentieel of niet? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/ontbijt.png" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/ontbijt.webp"
                                    type="image/webp"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/ontbijt.png"
                                    type="image/jpeg"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/ontbijt.png"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Ontbijten, essentieel of niet?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Hallo daar, ontbijtliefhebbers en vastenfanatici!
                        Vandaag gaan we het hebben over een onderwerp dat zo oud
                        is als de tijd zelf (of in ieder geval zo oud als de
                        uitvinding van de cornflakes): het ontbijt. Is het echt
                        de belangrijkste maaltijd van de dag, of is het gewoon
                        een slimme marketingtruc van de Kellogg's van deze
                        wereld? Laten we eens duiken in de wereld van de vroege
                        vogels en de late slapers. WE ARE – Personal training
                        Uden en Schijndel.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Ontbijt: De Held van de Ochtend
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Je hebt het waarschijnlijk al honderden keren gehoord:
                        "Ontbijt is de belangrijkste maaltijd van de dag". Maar
                        waarom is dat eigenlijk zo?
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Volgens een studie van Betts et al. (2016) kan het
                        overslaan van het ontbijt leiden tot een verhoogd risico
                        op obesitas, hartziekten en diabetes type 2. Het ontbijt
                        kickstart je{" "}
                        <a
                            href={route("blogs.forty-six")}
                            className="text-we-are-yellow"
                        >
                            metabolisme
                        </a>{" "}
                        en helpt je om gedurende de dag minder te eten.
                        Bovendien kan het je concentratie en prestaties op
                        school of werk verbeteren (Leidy et al., 2013).En laten
                        we eerlijk zijn, wie wil er nu niet de dag beginnen met
                        een lekkere{" "}
                        <a
                            href={route("blogs.forty-one")}
                            className="text-we-are-yellow"
                        >
                            eiwit
                        </a>{" "}
                        shake of een kom yoghurt met vers fruit en granola?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Periodiek Vasten: De Stille Kracht
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Aan de andere kant hebben we{" "}
                        <a
                            href={route("blogs.forty")}
                            className="text-we-are-yellow"
                        >
                            periodiek vasten
                        </a>
                        , een trend die de afgelopen jaren enorm in populariteit
                        is toegenomen. De aanhangers van deze levensstijl
                        beweren dat het overslaan van het ontbijt (of een andere
                        maaltijd) kan leiden tot gewichtsverlies, verbeterde
                        mentale helderheid en een langere levensduur (Patterson
                        & Sears, 2017).En laten we eerlijk zijn, wie wil er nu
                        niet een paar extra minuten in{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                        >
                            bed
                        </a>{" "}
                        blijven liggen in plaats van vroeg op te staan om een
                        kom havermout te maken?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Ontbijt vs. Vasten
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Dus, wat is nu beter: ontbijten of vasten? Het antwoord
                        is... tromgeroffel... het hangt af van jou! Elk lichaam
                        is uniek en wat voor de één werkt, werkt misschien niet
                        voor de ander. Als je 's ochtends honger hebt en merkt
                        dat je zonder ontbijt niet goed kunt functioneren, ga
                        dan je gang en geniet van dat ontbijt. Maar als je merkt
                        dat je 's ochtends geen honger hebt en je prima voelt
                        bij het overslaan van het ontbijt, dan is dat ook
                        prima.Het belangrijkste is om naar je lichaam te
                        luisteren en te doen wat voor jou het beste voelt en wat
                        de beste{" "}
                        <a
                            href={route("blogs.twenty-six")}
                            className="text-we-are-yellow"
                        >
                            resultaten
                        </a>{" "}
                        oplevert.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Of je nu team ontbijt of team vasten bent, we kunnen het
                        allemaal eens zijn over één ding: het is belangrijk om
                        je dag te beginnen met iets dat je gelukkig maakt. Of
                        dat nu een kom muesli is of een paar extra minuten in
                        bed, het is helemaal aan jou. Dus ga je gang, pak die
                        lepel (of dat dekbed) en maak er een geweldige dag van!
                    </p>

                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Betts, J. A., Richardson, J. D., Chowdhury, E. A.,
                        Holman, G. D., Tsintzas, K., & Thompson, D. (2016). The
                        causal role of breakfast in energy balance and health: a
                        randomized controlled trial in obese adults. American
                        Journal of Clinical Nutrition, 103(3), 747-756.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Leidy, H. J., Ortinau, L. C., Douglas, S. M., & Hoertel,
                        H. A. (2013). Beneficial effects of a higher-protein
                        breakfast on the appetitive, hormonal, and neural
                        signals controlling energy intake regulation in
                        overweight/obese, “breakfast-skipping,” late-adolescent
                        girls. American Journal of Clinical Nutrition, 97(4),
                        677-688.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Patterson, R. E., & Sears, D. D. (2017). Metabolic
                        effects of intermittent fasting. Annual Review of
                        Nutrition, 37, 371-393.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
